/**
 * Default SEO copy for the marketing shell. Keep `index.html` meta/title/OG in sync with these strings.
 */
export const SEO_DEFAULT_TITLE_SEGMENT = 'Fantasy Premier League Player Duels & Predictions';

export const SEO_DEFAULT_DESCRIPTION =
  'Vote in 1v1 Fantasy Premier League player duels, see collective odds, and climb the leaderboard. Join thousands of FPL managers making better decisions.';

/** Full document title when no page-specific segment is set (must match `| CrowdFPL` pattern). */
export const SEO_DEFAULT_FULL_TITLE = `${SEO_DEFAULT_TITLE_SEGMENT} | CrowdFPL`;
